import React from "react";

const Upload = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_282_5027)">
      <path
        d="M2.5 12.6668H14.5V14.0002H2.5V12.6668ZM9.16667 3.8855V11.3335H7.83333V3.8855L3.786 7.9335L2.84333 6.99083L8.5 1.3335L14.1567 6.99016L13.214 7.93283L9.16667 3.88683V3.8855Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_282_5027">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(Upload);
